export default __webpack_public_path__ + "static/media/forget-password.963bb213.png";